export default function useVisibilityProducts() {
  /********************
   * FUNCTIONS         *
   ********************/
  function visibilityProducts(campsite: any) {
    const visibilityProducts = {
      hasConversionOptimization: false,
      hasTraffic: false,
    };

    if (!campsite || !campsite.purchases) {
      return visibilityProducts;
    }

    visibilityProducts.hasConversionOptimization = campsite.purchases.includes(2);
    visibilityProducts.hasTraffic = campsite.purchases.includes(8);

    return visibilityProducts;
  }

  return {
    visibilityProducts,
  };
}
